import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main-layout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  class: "flex col g24 justify-center",
  style: {"width":"900px","max-width":"80vw"}
}
const _hoisted_4 = {
  style: {"display":"none"},
  ref: "stateLabel",
  class: "text-red"
}
const _hoisted_5 = { class: "flex align-center justify-center" }
const _hoisted_6 = {
  class: "flex align-center justify-center",
  ref: "roleSection"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Role : ", -1)
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "flex align-center justify-center grow" }
const _hoisted_10 = {
  style: {"white-space":"nowrap"},
  class: "text-muted"
}
const _hoisted_11 = { class: "flex align-center justify-center grow" }
const _hoisted_12 = {
  style: {"white-space":"nowrap"},
  class: "text-muted"
}
const _hoisted_13 = { class: "flex align-center justify-center grow" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  style: {"white-space":"nowrap"},
  class: "text-muted"
}, " Etablissement : ", -1)
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_SeInput = _resolveComponent("SeInput")!
  const _component_SeDropdownItem = _resolveComponent("SeDropdownItem")!
  const _component_SeDropdown = _resolveComponent("SeDropdown")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_AccountList = _resolveComponent("AccountList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavHeader, {
      title: _ctx.Lang.getI18N('accounts')
    }, null, 8, ["title"]),
    _createVNode(_component_SearchBar, {
      ref: "searchBar",
      targetGridId: "accountGrid",
      searchChange: _ctx.searchChange,
      newCallback: _ctx.openAccountModal,
      btnText: _ctx.canCreateDistributor() ? _ctx.Lang.getI18N('new') : undefined,
      class: "sticky",
      modelValue: _ctx.state.displayUnactives,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.displayUnactives) = $event))
    }, null, 8, ["searchChange", "newCallback", "btnText", "modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SeModal, {
        title: _ctx.Lang.getI18N('new'),
        ref: "accountModal"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, " [Alert message]", 512),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SeInput, {
                ref: "email",
                placeholder: "Email"
              }, null, 512),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_SeDropdown, {
                  modelValue: _ctx.state.selectedRole,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedRole) = $event)),
                  titleFunc: (x) => _ctx.Lang.getI18N(x),
                  ref: "role"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SeDropdownItem, {
                      value: _ctx.Role.Manager
                    }, null, 8, ["value"]),
                    _createVNode(_component_SeDropdownItem, {
                      value: _ctx.Role.Customer
                    }, null, 8, ["value"]),
                    _createVNode(_component_SeDropdownItem, {
                      value: _ctx.Role.Distributor
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "titleFunc"])
              ], 512),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Lang.getI18N("distributor")) + " : ", 1),
                  _createVNode(_component_SeDropdown, {
                    search: true,
                    modelValue: _ctx.state.selectedDistributor,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.selectedDistributor) = $event)),
                    titleFunc: (distributor) => distributor.name
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.distributors.filter(
                    (x) => x.active
                  ), (distributor) => {
                        return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                          key: distributor.ref?.id,
                          value: distributor
                        }, null, 8, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "titleFunc"])
                ], 512), [
                  [_vShow, _ctx.state.selectedRole == _ctx.Role.Distributor]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.Lang.getI18N("database")) + " : ", 1),
                  _createVNode(_component_SeDropdown, {
                    search: true,
                    modelValue: _ctx.state.selectedDatabase,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.selectedDatabase) = $event)),
                    titleFunc: (database) => database.name
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.databases, (database) => {
                        return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                          key: database.ref?.id,
                          value: database
                        }, null, 8, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "titleFunc"])
                ], 512), [
                  [_vShow, _ctx.state.selectedRole == _ctx.Role.Manager]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_SeDropdown, {
                    search: true,
                    modelValue: _ctx.state.selectedStore,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.selectedStore) = $event)),
                    titleFunc: (store) => store.name
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.stores.filter((x) => x.active), (store) => {
                        return (_openBlock(), _createBlock(_component_SeDropdownItem, {
                          key: store.ref?.id,
                          value: store
                        }, null, 8, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "titleFunc"])
                ], 512), [
                  [_vShow, _ctx.state.selectedRole == _ctx.Role.Customer]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_SeInput, {
                ref: "password",
                placeholder: _ctx.Lang.getI18N('password'),
                type: "password"
              }, null, 8, ["placeholder"]),
              _createVNode(_component_SeInput, {
                ref: "passwordConf",
                type: "password",
                placeholder: _ctx.Lang.getI18N('password-conf')
              }, null, 8, ["placeholder"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_SeInput, {
                ref: "name",
                placeholder: _ctx.Lang.getI18N('name')
              }, null, 8, ["placeholder"]),
              _createVNode(_component_SeInput, {
                ref: "surname",
                placeholder: _ctx.Lang.getI18N('surname')
              }, null, 8, ["placeholder"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_SeInput, {
                placeholder: _ctx.Lang.getI18N('phone-number'),
                ref: "phone"
              }, null, 8, ["placeholder"])
            ]),
            _createVNode(_component_SeButton, {
              class: "modal-valid w100",
              ref: "createBtn",
              onPress: _ctx.addAccount,
              icon: "/ico/plus.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("create")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_AccountList, {
        unactives: _ctx.state.displayUnactives,
        ref: "accountList",
        accounts: _ctx.manager.getUsers()
      }, null, 8, ["unactives", "accounts"])
    ])
  ]))
}